import React from "react";
import Pill from "../Pill/Pill";
import styles from "./PillsGroup.module.css";
import { PillProps } from "../../common-types/Pill";

interface PillContainerProps {
  pills: PillProps[];
}

const PillsGroup: React.FC<PillContainerProps> = ({ pills }) => {
  return (
    <div className={styles["container"]}>
      {pills.map((pill, index) => (
        <Pill key={index} {...pill} />
      ))}
    </div>
  );
};

export default PillsGroup;
